function GetYear() {
    var date = new Date();

    return (date.getFullYear());
}

export default GetYear;
